import React from "react";
import { Table } from "reactstrap";

const PreliminaryDetailsTab = ({ valuation }) => {
    if (!valuation) return <p>No data available</p>;

    return (
        <div>
            <h5 className="mb-3 text-primary">Preliminary Details</h5>
            <Table bordered hover responsive>
                <tbody>
                    <tr>
                        <th>Valuation Ref</th>
                        <td>{valuation.valuation_ref}</td>
                    </tr>
                    <tr>
                        <th>Project</th>
                        <td>{valuation.project?.name}</td>
                    </tr>
                    <tr>
                        <th>Client</th>
                        <td>{valuation.client?.name}</td>
                    </tr>
                    <tr>
                        <th>Property Owner</th>
                        <td>
                            {valuation.property?.owner
                                ? `${valuation.property.owner.first_name} ${valuation.property.owner.middle_name || ""} ${valuation.property.owner.last_name}`
                                : "-"}
                        </td>
                    </tr>
                    <tr>
                        <th>Valuer</th>
                        <td>
                            {valuation.valuer
                                ? `${valuation.valuer.first_name} ${valuation.valuer.last_name} (${valuation.valuer.company})`
                                : "-"}
                        </td>
                    </tr>
                    <tr>
                        <th>Captured By</th>
                        <td>
                            {valuation.captured_by
                                ? `${valuation.captured_by.first_name} ${valuation.captured_by.last_name}`
                                : "-"}
                        </td>
                    </tr>
                    <tr>
                        <th>Valuation Date</th>
                        <td>{valuation.valuation_date}</td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td>
                            <span className="badge bg-info">{valuation.status}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>Valuation Methods</th>
                        <td>
                            {valuation.valuation_methods?.length ? (
                                <ul className="list-unstyled mb-0">
                                    {valuation.valuation_methods.map((m, idx) => (
                                        <li key={idx} className="d-flex align-items-center mb-1">
                                            <i
                                                className="ri-arrow-right-circle-line text-primary me-2"
                                                style={{ fontSize: "16px" }}
                                            ></i>
                                            {m.name}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                "-"
                            )}
                        </td>
                    </tr>
                </tbody>
            </Table>
        </div>
    );
};

export default PreliminaryDetailsTab;
